import { useContext, useEffect } from "react";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";
import { DEFAULT_GITHUB_INSTANCE_SLUG, urlInstanceSlug } from "@/lib/named-org";
import { AuthContext } from "@/components/AuthProvider";
import { useConnectedGithubOrgs } from "@/hooks/useConnectedGithubOrgs";
import { MainPaneLoader } from "@/components/MainPaneLoader";

export default function WelcomeDialog() {
  const router = useRouter();
  const { user } = useContext(AuthContext);
  const { connectedGithubOrgs } = useConnectedGithubOrgs();

  useEffect(() => {
    if (
      !user ||
      !connectedGithubOrgs ||
      connectedGithubOrgs.installations.length
    )
      return;
    const instance = urlInstanceSlug(
      undefined,
      undefined,
      user.default_instance_slug,
    );
    router.replace(
      instance === DEFAULT_GITHUB_INSTANCE_SLUG
        ? "/welcome"
        : `/welcome?instance=${encodeURIComponent(instance)}`,
    );
  }, [router, user, connectedGithubOrgs]);

  return <MainPaneLoader />;
}
